import { gsap } from 'gsap'
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default {
  init() {
    console.log('single');

    new Swiper('.swiperSingleNewsRelated', {
			modules: [Navigation],
			slideToClickedSlide: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			slidesPerView: 3,
			breakpoints: {
				1024: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 2,
				},
				320: {
					slidesPerView: 1.1,
          			spaceBetween: 20,
				},
			},
			spaceBetween: 50,
			direction: 'horizontal',
			loop: false,
	});


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
